import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../../services/api';
import SweetAlert from 'react-bootstrap-sweetalert';
import InputMask from 'react-input-mask';
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer';
import './index.css';
import Swal from 'sweetalert2';

function AtendimentoForm() {

  const { loja } = useParams();

  const [locais, setLocais] = useState([]);
  const [localSelecionado, setLocalSelecionado] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [codLoja, setCodLoja] = useState(null);

  const [nome, setNome] = useState('');
  const [nomePessoa, setNomePessoa] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [descricao, setDescricao] = useState('');
  const [empresa, setEmpresa] = useState('');
  const [setorSelecionado, setSetorSelecionado] = useState('');

  const [maskTelefone] = useState('(99) 99999-9999');

  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');
  const [senhaInfo, setSenhaInfo] = useState(null);
  const [cliId, setCliId] = useState(null);

  const [carregando, setCarregando] = useState(true);
  const [carregandoPosicao, setCarregandoPosicao] = useState(false);
  const [enviando, setEnviando] = useState(false);

  const intervaloRef = useRef(null);
  const audioRef = useRef(null);

  // =========================
  // NOTIFICAÇÃO
  // =========================

  useEffect(() => {

    if ('Notification' in window) {

      Notification.requestPermission();

    }

  }, []);

  // =========================
  // DESBLOQUEIA ÁUDIO IOS
  // =========================

  useEffect(() => {

    if (!audioRef.current) {

      audioRef.current = new Audio('/alarme.mp3');

      audioRef.current.preload = 'auto';

      audioRef.current.loop = true;

      audioRef.current.volume = 1;

      audioRef.current.playsInline = true;

    }

    const desbloquearAudio = () => {

      if (!audioRef.current) return;

      audioRef.current.load();

      document.removeEventListener(
        'touchstart',
        desbloquearAudio
      );

      document.removeEventListener(
        'click',
        desbloquearAudio
      );

    };

    document.addEventListener(
      'touchstart',
      desbloquearAudio,
      { passive: true }
    );

    document.addEventListener(
      'click',
      desbloquearAudio
    );

    return () => {

      document.removeEventListener(
        'touchstart',
        desbloquearAudio
      );

      document.removeEventListener(
        'click',
        desbloquearAudio
      );

    };

  }, []);

  // =========================
  // LOCAL STORAGE
  // =========================

  const salvarFilaLocal = (dados) => {

    localStorage.setItem(
      'fila_atendimento',
      JSON.stringify(dados)
    );

  };

  const limparFilaLocal = () => {

    localStorage.removeItem(
      'fila_atendimento'
    );

  };

  // =========================
  // RESTAURA FILA
  // =========================

  useEffect(() => {

    const filaSalva =
      localStorage.getItem(
        'fila_atendimento'
      );

    if (filaSalva) {

      try {

        const dados =
          JSON.parse(filaSalva);

        setSenhaInfo(dados);

        setCodLoja(
          dados.cli_loja
        );

        setLocalSelecionado(
          dados.cli_local
        );

        setShowPopup(false);

        setMostrarFormulario(false);

      } catch (e) {

        console.log(
          'Erro restaurando fila'
        );

        localStorage.removeItem(
          'fila_atendimento'
        );

      }

    }

  }, []);

  // =========================
  // CARREGA LOJA
  // =========================

  useEffect(() => {

    const filaSalva =
      localStorage.getItem(
        'fila_atendimento'
      );

    api.get(
      `/atendimento/loja/${loja}`
    )
      .then(res => {

        setLocais(res.data);

        if (
          res.data.length > 0
        ) {

          if (!filaSalva) {

            setLocalSelecionado(
              res.data[0].atend_local
            );

            setCodLoja(
              res.data[0].atend_loja
            );

            if (
              res.data[0]
                .atend_loja !== 1
            ) {

              setShowPopup(true);

            } else {

              setMostrarFormulario(true);

            }

          }

        }

      })
      .catch(() => {

        setErro(
          'Loja não encontrada!'
        );

      })
      .finally(() => {

        setCarregando(false);

      });

  }, [loja]);

  // =========================
  // POSIÇÃO FILA
  // =========================

  useEffect(() => {

    if (
      !senhaInfo?.senha ||
      !codLoja ||
      !localSelecionado
    ) return;

    intervaloRef.current =
      setInterval(async () => {

        try {

          setCarregandoPosicao(true);

          const res =
            await api.get(
              '/atendimento/fila/posicao',
              {
                params: {
                  cli_loja: codLoja,
                  cli_local:
                    localSelecionado,
                  cli_senha:
                    senhaInfo.senha
                }
              }
            );

          const novaPosicao =
            res.data.posicao ??
            res.data.Posicao ??
            0;

          setSenhaInfo(prev => {

            const atualizado = {
              ...prev,
              posicao:
                novaPosicao
            };

            salvarFilaLocal(
              atualizado
            );

            return atualizado;

          });

          if (
            novaPosicao === 0
          ) {

            clearInterval(
              intervaloRef.current
            );

            intervaloRef.current =
              null;

          }

        } catch {

          console.log(
            'Erro ao atualizar posição'
          );

        } finally {

          setCarregandoPosicao(
            false
          );

        }

      }, 30000);

    return () =>
      clearInterval(
        intervaloRef.current
      );

  }, [
    senhaInfo?.senha,
    codLoja,
    localSelecionado
  ]);

  // =========================
  // LIMPA ERRO
  // =========================

  useEffect(() => {

    if (erro) {

      const timer =
        setTimeout(() => {

          setErro('');

        }, 5000);

      return () =>
        clearTimeout(timer);

    }

  }, [erro]);

  // =========================
  // HELPERS
  // =========================

  const onlyNumbers = (str) =>
    str.replace(/\D/g, '');

  const limparCampos = () => {

    setNome('');
    setWhatsapp('');
    setDescricao('');
    setEmpresa('');
    setSetorSelecionado('');
    setNomePessoa('');

  };

  // =========================
  // VERIFICA CHAMADA
  // =========================

  useEffect(() => {

    const falarTexto = (texto) => {

      try {

        if (
          !('speechSynthesis' in window)
        ) {
          return;
        }

        window.speechSynthesis.cancel();

        const utterance =
          new SpeechSynthesisUtterance(
            texto
          );

        utterance.lang =
          'pt-BR';

        utterance.rate = 1;

        utterance.pitch = 1;

        utterance.volume = 1;

        const voices =
          window.speechSynthesis.getVoices();

        const vozPt =
          voices.find(v =>
            v.lang
              ?.toLowerCase()
              .includes('pt-br')
          ) ||
          voices.find(v =>
            v.lang
              ?.toLowerCase()
              .includes('pt')
          );

        if (vozPt) {

          utterance.voice =
            vozPt;

        }

        window.speechSynthesis.speak(
          utterance
        );

      } catch (e) {

        console.log(
          'Erro speech',
          e
        );

      }

    };

    const interval =
      setInterval(async () => {

        if (!senhaInfo?.senha)
          return;

        try {

          const res =
            await api.get(
              '/atendimento/chamada',
              {
                params: {
                  cli_loja:
                    codLoja,
                  cli_senha:
                    senhaInfo.senha,
                  cli_local:
                    localSelecionado
                }
              }
            );

          if (
            res.data.length > 0
          ) {

            const chamada =
              res.data[0];

            try {

              if (
                'Notification' in
                window &&
                Notification.permission ===
                'granted'
              ) {

                new Notification(
                  'Você está sendo chamado!',
                  {
                    body:
                      chamada.cli_chamada,
                    icon:
                      '/logo192.png'
                  }
                );

              }

            } catch (e) {

              console.log(
                'Erro notificação',
                e
              );

            }

            let reforcoAudio =
              null;

            try {

              if (
                audioRef.current
              ) {

                audioRef.current.pause();

                audioRef.current.currentTime = 0;

                audioRef.current.loop = true;

                await audioRef.current.play();

                reforcoAudio =
                  setInterval(() => {

                    try {

                      if (
                        audioRef.current &&
                        audioRef.current.paused
                      ) {

                        audioRef.current.currentTime = 0;

                        audioRef.current.play()
                          .catch(() => { });

                      }

                    } catch { }

                  }, 1500);

              }

            } catch (e) {

              console.log(
                'Erro play',
                e
              );

            }

            try {

              if (
                navigator.vibrate &&
                document.hasFocus()
              ) {

                navigator.vibrate([
                  1000,
                  500,
                  1000,
                  500,
                  1000
                ]);

              }

            } catch { }

            falarTexto(
              chamada.cli_chamada
            );

            const falaLoop =
              setInterval(() => {

                falarTexto(
                  chamada.cli_chamada
                );

              }, 8000);

            await Swal.fire({
              icon: 'success',
              title:
                'Você está sendo chamado!',
              html: `
                <div style="font-size:20px">
                  ${chamada.cli_chamada}
                </div>
              `,
              confirmButtonText:
                'OK',
              allowOutsideClick:
                false,
              allowEscapeKey:
                false
            });

            clearInterval(
              falaLoop
            );

            if (
              reforcoAudio
            ) {

              clearInterval(
                reforcoAudio
              );

            }

            window.speechSynthesis.cancel();

            try {

              if (
                audioRef.current
              ) {

                audioRef.current.pause();

                audioRef.current.currentTime = 0;

              }

            } catch { }

            await api.put(
              '/atendimento/notificado',
              {
                cli_loja:
                  codLoja,
                cli_senha:
                  senhaInfo.senha,
                cli_local:
                  localSelecionado
              }
            );

            limparFilaLocal();

            setSenhaInfo(null);

            setShowPopup(false);

            setMostrarFormulario(
              false
            );

          }

        } catch (err) {

          console.log(err);

        }

      }, 5000);

    return () => {

      clearInterval(interval);

      window.speechSynthesis.cancel();

      try {

        if (
          audioRef.current
        ) {

          audioRef.current.pause();

          audioRef.current.currentTime = 0;

        }

      } catch { }

    };

  }, [
    senhaInfo,
    codLoja,
    localSelecionado
  ]);

  // =========================
  // ENVIAR SENHA
  // =========================

  const enviarSenha = async (tipo) => {

    try {

      if (
        audioRef.current
      ) {

        await audioRef.current.play();

        audioRef.current.pause();

        audioRef.current.currentTime = 0;

      }

    } catch { }

    const payload = {
      cli_loja:
        codLoja.toString(),
      cli_local:
        localSelecionado,
      cli_status: 'I',
      cli_tipo: tipo,
      cli_nome: '',
      cli_whatsapp: '',
      cli_descricao: '',
      cli_empresa: ''
    };

    try {

      const res =
        await api.post(
          '/atendimento/fila',
          payload
        );

      const dadosFila = {
        ...res.data[0],
        cli_loja: codLoja,
        cli_local:
          localSelecionado
      };

      setSenhaInfo(
        dadosFila
      );

      salvarFilaLocal(
        dadosFila
      );

      setCliId(
        res.data[0].senha
      );

      limparCampos();

      setShowPopup(false);

      setMostrarFormulario(
        false
      );

      setSucesso(
        'Aguarde ser atendido: Sua senha é: ' +
        res.data[0].senha
      );

      window.scrollTo({
        top: 0,
        behavior:
          'smooth'
      });

    } catch (err) {

      setErro(
        'Erro ao solicitar senha.'
      );

    }

  };

  // =========================
  // ENVIAR ATENDIMENTO
  // =========================

  const enviarAtendimento =
    async () => {

      if (enviando)
        return;

      if (
        !nome.trim() ||
        !onlyNumbers(
          whatsapp
        ) ||
        !descricao.trim() ||
        !codLoja ||
        (
          codLoja === 1 &&
          !setorSelecionado
        ) ||
        (
          codLoja === 1 &&
          !nomePessoa.trim()
        )
      ) {

        setErro(
          'Preencha todos os campos obrigatórios corretamente.'
        );

        return;

      }

      setEnviando(true);

      const setorConcatenado =
        codLoja === 1
          ? `${setorSelecionado} - ${nomePessoa.trim()}`
          : setorSelecionado;

      const payload = {
        cli_loja:
          codLoja.toString(),
        cli_local:
          localSelecionado,
        cli_status: 'I',
        cli_tipo:
          codLoja === 1
            ? 'A'
            : 'S',
        cli_nome:
          nome.trim(),
        cli_whatsapp:
          onlyNumbers(
            whatsapp
          ),
        cli_descricao:
          descricao.trim(),
        cli_empresa:
          empresa.trim(),
        ...(codLoja === 1 && {
          cli_setor:
            setorConcatenado
        })
      };

      try {

        const res =
          await api.post(
            '/atendimento/fila',
            payload
          );

        const dadosFila = {
          ...res.data[0],
          cli_loja: codLoja,
          cli_local:
            localSelecionado
        };

        setSenhaInfo(
          dadosFila
        );

        salvarFilaLocal(
          dadosFila
        );

        setCliId(
          res.data[0].senha
        );

        limparCampos();

        setMostrarFormulario(
          false
        );

        setShowPopup(false);

        setSucesso(
          'Aguarde ser atendido: Sua senha é: ' +
          res.data[0].senha
        );

        window.scrollTo({
          top: 0,
          behavior:
            'smooth'
        });

      } catch (err) {

        setErro(
          'Erro ao enviar atendimento.'
        );

      } finally {

        setEnviando(false);

      }

    };

  return (

    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: '#fff'
      }}
    >

      <Menu modulo="Atendimento" />

      <main
        className="container-fluid pagina-dados"
        style={{
          flex: 1,
          paddingTop: '90px',
          paddingBottom: '40px'
        }}
      >

        <div className="row justify-content-center">

          <div className="col-12 col-md-10 col-lg-6">

            {carregando ? (

              <div className="text-center mt-5">
                Carregando...
              </div>

            ) : (

              <>

                {!senhaInfo &&
                  showPopup &&
                  !mostrarFormulario && (

                    <div className="popup-atendimento">

                      <h5>
                        Escolha o tipo de atendimento
                      </h5>

                      <p>
                        <b>Local:</b>{' '}
                        {localSelecionado}
                      </p>

                      {locais.length > 1 && (

                        <div className="mb-2">

                          <select
                            className="form-control"
                            value={
                              localSelecionado
                            }
                            onChange={(e) =>
                              setLocalSelecionado(
                                e.target.value
                              )
                            }
                          >

                            {locais.map((l, i) => (

                              <option
                                key={i}
                                value={
                                  l.atend_local
                                }
                              >
                                {
                                  l.atend_local
                                }
                              </option>

                            ))}

                          </select>

                        </div>

                      )}

                      <button
                        className="btn btn-primary w-100 mb-2"
                        onClick={() =>
                          enviarSenha('B')
                        }
                      >
                        Senha BALCÃO
                      </button>

                      <button
                        className="btn btn-warning w-100 mb-2"
                        onClick={() =>
                          enviarSenha('P')
                        }
                      >
                        Senha PRIORITÁRIO
                      </button>

                      <button
                        className="btn btn-success w-100"
                        onClick={() => {

                          setMostrarFormulario(
                            true
                          );

                          setShowPopup(
                            false
                          );

                        }}
                      >
                        Separação de Produtos
                      </button>

                    </div>

                  )}

                {!senhaInfo &&
                  mostrarFormulario && (

                    <>

                      <h3 className="mt-4 mb-3">
                        Inclusão na fila
                      </h3>

                      <div className="mb-3">

                        <label className="form-label">
                          Nome
                        </label>

                        <input
                          className="form-control"
                          type="text"
                          value={nome}
                          onChange={(e) =>
                            setNome(
                              e.target.value
                            )
                          }
                          placeholder="Digite seu nome"
                          maxLength={50}
                        />

                      </div>

                      <div className="mb-3">

                        <label className="form-label">
                          WhatsApp
                        </label>

                        <InputMask
                          className="form-control"
                          mask={
                            maskTelefone
                          }
                          value={
                            whatsapp
                          }
                          onChange={(e) =>
                            setWhatsapp(
                              e.target.value
                            )
                          }
                          placeholder="(99) 99999-9999"
                        />

                      </div>

                      {codLoja === 1 && (

                        <>

                          <div className="mb-3">

                            <label className="form-label">
                              Empresa
                            </label>

                            <input
                              className="form-control"
                              type="text"
                              value={empresa}
                              onChange={(e) =>
                                setEmpresa(
                                  e.target.value
                                )
                              }
                              placeholder="Empresa ou setor"
                              maxLength={30}
                            />

                          </div>

                          <div className="mb-3">

                            <label className="form-label">
                              Setor
                            </label>

                            <div className="d-flex flex-column">

                              {[
                                'COMERCIAL',
                                'CONTABILIDADE',
                                'FINANCEIRO',
                                'JURIDICO',
                                'PSCICOLOGA',
                                'RECURSOS HUMANOS',
                                'TI'
                              ].map((setor, index) => (

                                <div
                                  className="form-check"
                                  key={index}
                                >

                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="setor"
                                    id={`setor-${index}`}
                                    value={setor}
                                    checked={
                                      setorSelecionado === setor
                                    }
                                    onChange={() =>
                                      setSetorSelecionado(setor)
                                    }
                                  />

                                  <label
                                    className="form-check-label"
                                    htmlFor={`setor-${index}`}
                                  >
                                    {setor}
                                  </label>

                                </div>

                              ))}

                              {setorSelecionado && (

                                <div className="mb-3 mt-3">

                                  <label className="form-label">
                                    Nome da pessoa que deseja falar
                                  </label>

                                  <input
                                    className="form-control"
                                    type="text"
                                    value={nomePessoa}
                                    onChange={(e) =>
                                      setNomePessoa(
                                        e.target.value
                                      )
                                    }
                                    placeholder="Digite o nome da pessoa"
                                    maxLength={50}
                                  />

                                </div>

                              )}

                            </div>

                          </div>

                        </>

                      )}

                      <div className="mb-3">

                        <label className="form-label">

                          {codLoja === 1
                            ? 'Descrição'
                            : 'Pedido'}

                        </label>

                        <textarea
                          className="form-control"
                          rows={3}
                          value={descricao}
                          onChange={(e) =>
                            setDescricao(
                              e.target.value
                            )
                          }
                          placeholder={
                            codLoja === 1
                              ? 'Informe o assunto'
                              : 'Informe os produtos desejados'
                          }
                        />

                      </div>

                      <div
                        style={{
                          paddingBottom: '120px'
                        }}
                      >

                        <button
                          className="btn btn-primary w-100"
                          onClick={
                            enviarAtendimento
                          }
                          disabled={
                            enviando
                          }
                        >

                          {enviando ? (

                            <>

                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>

                              Enviando...

                            </>

                          ) : (

                            'Enviar'

                          )}

                        </button>

                      </div>

                    </>

                  )}

                {senhaInfo && (

                  <div
                    className="alert alert-success text-center"
                    style={{
                      paddingBottom: '120px'
                    }}
                  >

                    <h5>
                      Sua senha:{' '}
                      <b>
                        {senhaInfo.senha}
                      </b>
                    </h5>

                    {carregandoPosicao && (

                      <div className="d-flex justify-content-center my-2">

                        <div
                          className="spinner-border text-success"
                          role="status"
                          style={{
                            width: '2rem',
                            height: '2rem'
                          }}
                        >

                          <span className="visually-hidden">
                            Carregando...
                          </span>

                        </div>

                      </div>

                    )}

                    {senhaInfo.posicao !== undefined && (

                      senhaInfo.posicao === 1 ? (

                        <p className="posicao-animada">
                          Você é o próximo
                        </p>

                      ) : (

                        <p className="posicao-animada">
                          Sua posição é:{' '}
                          {senhaInfo.posicao}
                        </p>

                      )

                    )}

                  </div>

                )}

              </>

            )}

          </div>

        </div>

      </main>

      {erro && (

        <SweetAlert
          danger
          title="Erro"
          onConfirm={() =>
            setErro('')
          }
        >
          {erro}
        </SweetAlert>

      )}

      {sucesso && (

        <SweetAlert
          success
          title="Sucesso"
          onConfirm={() =>
            setSucesso('')
          }
        >
          {sucesso}
        </SweetAlert>

      )}

      <Footer />

    </div>

  );

}

export default AtendimentoForm;